import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'
import { get } from 'lodash'

import { useBreakpoint } from '../../../../hooks/breakpoint'
import Download from '../action/download'
import Typography from '../../typography'
import Icon from '../../icon'
import Player from './player'
import BanuuIsotype from '../../icon/banuu-isotipo.svg'
import { KIND_ICON_MAP, KIND_LABEL_MAP, KIND_COLOR_MAP, KIND_AUDIO } from '../constants'

const Header = ({ resource, ...attrs }) => {
  const breakpoint = useBreakpoint()
  const kindIcon = KIND_ICON_MAP[resource.kind]
  const kindLabel = resource.kindLabel || KIND_LABEL_MAP[resource.kind]
  const kindColor = KIND_COLOR_MAP[resource.kind]
  const hasFile = !!get(resource, 'document.meta.downloadUrl', null) || !!get(resource, 'multimedia.meta.downloadUrl', null)
  const hasEmbedCode = !!resource.embedCode

  return <section
    className={
      classNames(
        [
          'relative',
          'pt-10',
          'md:pt-0',
          'bg-white'
        ]
      )
    }>
    <div
      className={
        classNames([
          breakpoint.mdAndUp ? '' : 'relative',
          'container',
          'px-4'
        ])
      }>
      <div
        className={
          classNames([
            'grid',
            'grid-cols-1',
            'md:grid-cols-2',
            '-mx-4'
          ])
        }
        style={
          {
            minHeight: '25rem'
          }
        }>
        <div
          className={
            classNames([
              'relative',
              'px-4',
              'pb-6',
              'md:pb-0',
              'pt-12',
              'md:pt-24'
            ])
          }>
          <div
            className={
              classNames(
                [
                  'h-full',
                  'w-full',
                  'md:w-5/6',
                  'flex',
                  'flex-col',
                  'justify-between'
                ]
              )
            }>
            <div>
              <div
                className={
                  classNames(
                    [
                      'flex',
                      'items-center',
                      'justify-between',
                      'mb-4'
                    ]
                  )
                }>
                <Typography
                  className={'text-green-500'}>
                  {kindLabel}
                </Typography>
                <Typography>
                  {
                    moment(resource.meta.firstPublishedAt).format('DD/MM/YYYY')
                  }
                </Typography>
              </div>
              <Typography
                weight={'black'}
                size={breakpoint.mdAndUp ? 'six' : 'five'}
                className={'mb-6 tracking-tight'}>
                {resource.title}
              </Typography>
            </div>
            {
              (resource.kind === KIND_AUDIO && !hasEmbedCode)
                ? <Player
                  resource={resource} />
                : null
            }
            {
              (resource.kind === KIND_AUDIO)
                ? (hasFile && breakpoint.smAndDown)
                  ? < Download
                    className={'mt-6'}
                    resource={resource} />
                  : null
                : hasFile
                  ? < Download
                    className={'mt-6'}
                    resource={resource} />
                  : null
            }
          </div>
        </div>
        <div
          className={
            classNames([
              kindColor
            ])
          }
          style={{
            borderRadius: breakpoint.mdAndUp ? '7.5rem 0 0 0' : '0',
            width: breakpoint.mdAndUp ? '50vw' : '100%',
            height: breakpoint.mdAndUp ? '100%' : '18rem'
          }}>
          <div
            className={
              classNames([
                'h-full',
                'w-full',
                'relative',
                'overflow-hidden'
              ])
            }>
            <Icon
              svg={BanuuIsotype}
              width={breakpoint.mdAndUp ? '125%' : '150%'}
              height={'auto'}
              className={
                classNames(
                  [
                    'z-0',
                    'opacity-10',
                    'absolute',
                    'left-8',
                    'bottom-0'
                  ]
                )
              } />

            <Icon
              svg={kindIcon}
              width={breakpoint.mdAndUp ? 230 : 100}
              height={breakpoint.mdAndUp ? 231 : 100}
              className={
                classNames(
                  [
                    'absolute',
                    'top-1/2',
                    'left-1/2',
                    'transform',
                    '-translate-x-1/2',
                    '-translate-y-1/2',
                    'md:top-24',
                    'md:left-20',
                    'md:transform-none'
                  ]
                )
              } />
          </div>
        </div>
      </div>
    </div>
  </section>
}

Header.propTypes = {
  resource: PropTypes.object
}

export default Header
